import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { measurementConsent, saveMeasurementConsent, trackPage } from '@/lib/measurement'

export function Measurement() {
  const location = useLocation()
  const [open, setOpen] = useState(() => measurementConsent() === null)
  useEffect(() => {
    const show = () => setOpen(true)
    window.addEventListener('origem:privacy-settings',show)
    return () => window.removeEventListener('origem:privacy-settings',show)
  },[])
  useEffect(() => { trackPage() },[location.pathname,location.search])
  if (!open) return null
  function choose(granted: boolean) { saveMeasurementConsent(granted); setOpen(false) }
  return (
    <section aria-label="Preferências de medição" className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-xl border border-border bg-background p-5 shadow-xl sm:inset-x-6">
      <h2 className="text-base font-bold">Medição de visitas e compras</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Com sua permissão, usamos Google Analytics e Google Ads para medir visitas,
        compras e campanhas. Placa, e-mail e dados do relatório ficam fora dessa medição.
        Você pode mudar sua escolha em “Preferências de cookies”, no rodapé.
      </p>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <Button variant="outline" onClick={() => choose(false)}>Recusar medição</Button>
        <Button onClick={() => choose(true)}>Permitir medição</Button>
        <Link to="/privacidade" className="text-sm text-brand underline">Política de privacidade</Link>
      </div>
    </section>
  )
}
